export default {
  announcements_title: "announcements",
};
